import { FormControl } from '@mui/material';
import { t } from 'i18next';
import React, { FC, useState, useEffect } from 'react';
import { SelectStyled, ArrowDropDownIconStyled } from '../../../../../../theme/style';
import { SelectedQuestionProps } from '../../../dashboardModalInterface';
import { PlaceholderInputStyled, MenuItemSelectStyled } from '../../styled';

interface QuantilesDropdownProps {
    hasQuartilesView: boolean
    quantilesQuestions: SelectedQuestionProps[]
    selectedQuartileQuestion?: SelectedQuestionProps
    handleSelectedQuartileQuestion: (question: SelectedQuestionProps) => void
}

const QuantilesDropdown: FC<QuantilesDropdownProps> = ({ quantilesQuestions, hasQuartilesView, selectedQuartileQuestion, handleSelectedQuartileQuestion }) => {
    // Store the question_id instead of label
    const [menuItemValue, setMenuItemValue] = useState<number | string>(
        selectedQuartileQuestion ? selectedQuartileQuestion.question_id : '',
    );

    const handleChangeSelectQuantilesQuestion = (questionId: number) => {
        const selectedQuestion = quantilesQuestions.find((q) => (q.question_id === questionId));
        if (selectedQuestion) {
            handleSelectedQuartileQuestion(selectedQuestion);
        }
    };

    useEffect(() => {
        if (selectedQuartileQuestion) {
            setMenuItemValue(selectedQuartileQuestion.question_id);
        }
    }, [selectedQuartileQuestion]);

    const SelectQuantilesQuestion = () => (
        <SelectStyled
            IconComponent={() => <ArrowDropDownIconStyled />}
            disabled={!hasQuartilesView}
            onChange={
                (e: React.ChangeEvent<HTMLInputElement>) => handleChangeSelectQuantilesQuestion(Number(e.target.value))
            }
            renderValue={(selected: string | number) => {
                if (selected === '' || selected === undefined) {
                    return <PlaceholderInputStyled> {t('dashboard:addIndicatorModal.commonAddIndicator.selectInputPlaceholder')}</PlaceholderInputStyled>;
                }

                // Find the question by ID to display its label
                const question = quantilesQuestions.find((q) => (q.question_id === Number(selected)));

                return question ? question.label : '';
            }}
            value={menuItemValue}
            displayEmpty
        >
            {quantilesQuestions.map((question: SelectedQuestionProps) => (
                <MenuItemSelectStyled
                    key={question.question_id}
                    value={question.question_id}
                >{question.label}
                </MenuItemSelectStyled>
            ))}
        </SelectStyled>
    );

    return (
        <FormControl>
            <SelectQuantilesQuestion />
        </FormControl>
    );
};

export default QuantilesDropdown;
